/* global IS_PRODUCTION */

const css = {
  warn: `
    background: yellow;
    color: black;
    font-size: large;
  `,
  error: `
    background: red;
    color: white;
    font-size: large;
  `,
  trace: `
    background: cyan;
    color: black;
  `
};

const levelsToIgnoreInProduction = ['trace'];

const writeLog = (level, ...args) => {
  if (IS_PRODUCTION && levelsToIgnoreInProduction.includes(level)) {
    return;
  }
  const arg = args.join(' ');
  if (typeof arg === 'string') {
    return console.log(`module-marketing-loader: %c${arg}`, css[level]);
  }
  if (Array.isArray(arg)) {
    return console.table(arg);
  }
  console.log(arg);
};
export const warn = writeLog.bind(null, 'warn');
export const error = writeLog.bind(null, 'error');
export const trace = writeLog.bind(null, 'trace');
